import React from 'react'
import PropTypes from 'prop-types'

const Header = ({ title, status, location, noOfPasses, startDate, endDate }) => {
  const headerClass = 'text-xs text-primary-lightgray font-bold'
  const valueClass = 'mt-2 text-sm text-primary-black'

  const colorStyles = {
    active: 'bg-lightgreen',
    cancelled: 'bg-free-speech-red',
    expired: 'bg-primary-lightgray font-normal',
  }

  return (
    <>
      <h3 className="text-base font-semibold flex items-center">
        {title}
        <span
          className={`text-white text-xs rounded ml-6 uppercase px-4 py-1 ${colorStyles[status]}`}
        >
          {status}
        </span>
      </h3>
      <div className="flex justify-between my-5">
        <div className="pl-0 pr-2">
          <p className={headerClass}>START DATE</p>
          <p className={valueClass}>{startDate}</p>
        </div>
        {endDate && (
          <div className="pl-0 pr-2">
            <p className={headerClass}>END DATE</p>
            <p className={valueClass}>{endDate}</p>
          </div>
        )}
        <div className="pl-0 pr-2">
          <p className={headerClass}>LOCATION</p>
          <p className={valueClass}>{location}</p>
        </div>
        <div className="pl-0 pr-2">
          <p className={headerClass}>NUMBER OF PASSES</p>
          <p className={valueClass}>{noOfPasses}</p>
        </div>
      </div>
    </>
  )
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  location: PropTypes.string,
  noOfPasses: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string,
  isTrial: PropTypes.bool,
  isRecurrent: PropTypes.bool,
  nextBill: PropTypes.string,
  price: PropTypes.string,
}

export default Header
